<template>
  <table class="table">
    <thead>
      <tr>
        <slot name="columns">
          <th v-for="(column, index) in columns" :key="index">{{ column }}</th>
        </slot>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, idx) in data" :key="idx">
        <slot :row="item">
          <td v-for="(column, index) in columns" :key="index">
            {{ hasValue(item, column) ? itemValue(item, column) : '' }}
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'l-table',
  props: {
    columns: Array,
    data: Array,
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
  },
};
</script>
<style></style>
